import styled from 'styled-components';

import { PAGES } from 'constants/pages';

import { Header, HeaderTitle } from 'components/Header';
import { PageTitle } from 'components/PageTitle';

import { NtfyMessagesList } from './components/NtfyMessagesList';

export const Ntfy = () => (
    <Container>
        <Header>
            <HeaderTitle>
                <PageTitle page={PAGES.ntfy} />
            </HeaderTitle>
        </Header>
        <Content>
            <NtfyMessagesList />
        </Content>
    </Container>
);

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
    color: ${({ theme }) => theme.textColor};
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: 15px;
    flex: 1;
    overflow: hidden;
`;
